<template>
  <div class="report">
    <h1 v-text="$t('raport_g4_gri')"/>
    <report-section :id="1"/>
  </div>
</template>

<script>
import ReportSection from '@/components/ReportSection.vue'

export default {
  components: {
    ReportSection
  }
}
</script>

<style lang="scss" scoped>
$mobile-breakpoint: 960px;

div.report {
  background-color: #E6E7E8;
  padding: 2rem 0 2rem 3rem;
  @media screen and (min-width: $mobile-breakpoint + 1) {
    padding: 4rem 0 4rem 6rem;
  }
  flex-grow: 1;
  flex-basis: 0px;
}
h1 {
  font-weight: 900;
  font-size: 3rem;
  line-height: 3rem;
  color: #e41e2b;
  text-transform: uppercase;
  margin-bottom: 1rem;
}
</style>
